export default __webpack_public_path__ + "static/media/manas.b944ca4c.png";